<template>
  <div class="mt-4 form-material">
    <div class="form-row text-small">
      <input-field
        class="col-4"
        :defValue.sync="branch"
        :field="{ name: 'branch', label: 'Rama', editor: 'text' }"
      ></input-field>
      <select-input
        class="col-4"
        :currentValue.sync="custom"
        :fieldOptions="customsList"
        label="Custom"
        fieldName="CustomCode"
      ></select-input>
      <button
        type="button"
        class="btn btn-primary mb-2 col-3 mx-2"
        @click="syncBoth"
        :disabled="!custom || supportDeploying"
      >
        Sync Server + Front
      </button>
      <button
        type="button"
        class="btn btn-primary mb-2 col-3 mx-2"
        @click="syncServer"
        :disabled="!custom || supportDeploying"
      >
        Sync Server
      </button>
      <button
        type="button"
        class="btn btn-primary mb-2 col-3 mx-2"
        @click="syncFront"
        :disabled="!custom || supportDeploying"
      >
        Sync Front
      </button>

      <button
        type="button"
        class="btn btn-primary mb-2 col-3 mx-2"
        @click="getBackup"
        :disabled="!custom"
      >
        Obtener backup
      </button>
    </div>

    <system-logs
      :show="showServerLogs"
      :build-id="syncServerJobId"
      :environment="syncEnvironmentLabelServer"
      :is-live="isServerPolling"
      :logs="syncServerLogs"
      @close="stopServerPolling"
    ></system-logs>

    <system-logs
      :show="showFrontLogs"
      :build-id="syncFrontJobId"
      :environment="syncEnvironmentLabelFront"
      :is-live="isFrontPolling"
      :logs="syncFrontLogs"
      @close="stopFrontPolling"
    ></system-logs>
  </div>
</template>

<script>
import SystemLogs from '@/components/tools/SystemLogs.vue'

export default {
  name: "update-support-environment",
  components: { SystemLogs },
  props: [],
  data() {
    return {
        customsList: [
            {value: 'aotg', label: 'Argentina On The Go'},
            {value: 'nwtd', label: 'New World Travel Designers'},
            {value: 'signa', label: 'Signature'},
            {value: 'dstrip', label: 'Designer trips'},
            {value: 'innova', label: 'Innova'},
            {value: 'mater', label: 'Mater Sustentable'},
            {value: 'raja', label: 'Raja'},
            {value: 'gador', label: 'Gador'},
            {value: 'quarum', label: 'Quarum'},
        ],
        custom: '',
        branch: '',
        syncServerJobId: null,
        syncFrontJobId: null,

        syncServerLogs: [],
        syncFrontLogs: [],

        showServerLogs: false,
        showFrontLogs: false,

        serverPolling: null,
        serverStatusPolling: null,
        serverLastStatus: null,

        frontPolling: null,
        frontStatusPolling: null,
        frontLastStatus: null,

        supportDeployingRaw: false,
        supportDeployPolling: null,
    };
  },
  computed: {
    supportDeploying () {
      return this.supportDeployingRaw || this.isServerPolling || this.isFrontPolling
    },
    isServerPolling () {
      return !!(this.serverPolling || this.serverStatusPolling)
    },
    isFrontPolling () {
      return !!(this.frontPolling || this.frontStatusPolling)
    },
    baseEnvironmentLabel () {
      const c = this.custom || ''
      const b = this.branch || ''
      if (c && b) return `${c} / ${b}`
      return c || b || 'support'
    },
    syncEnvironmentLabelServer () {
      return `${this.baseEnvironmentLabel} / server`
    },
    syncEnvironmentLabelFront () {
      return `${this.baseEnvironmentLabel} / front`
    }
  },
  beforeDestroy () {
    this.stopServerPolling()
    this.stopFrontPolling()
    if (this.supportDeployPolling) {
      clearInterval(this.supportDeployPolling)
      this.supportDeployPolling = null
    }
  },
  async mounted () {
    this.updateSupportDeploying()
    this.supportDeployPolling = setInterval(this.updateSupportDeploying, 2000)
  },
  methods: {
        async updateSupportDeploying () {
          try {
            const data = await api.get('/api/support_deploying/')
            this.supportDeployingRaw = !!data
          } catch (e) {
            // si falla, no bloqueamos desde UI (el backend igual bloquea)
            this.supportDeployingRaw = false
          }
        },
    tr(key) {
      if (window.tr && typeof window.tr === "function") return window.tr(key);
      if (this.$t && typeof this.$t === "function") return this.$t(key);
      return key;
    },
    startServerPolling () {
      this.clearServerPolling()
      this.serverStatusPolling = setInterval(this.updateServerStatus, 2000)
      this.serverPolling = setInterval(this.updateServerLogs, 2000)
      this.updateServerStatus()
      this.updateServerLogs()
    },
    startFrontPolling () {
      this.clearFrontPolling()
      this.frontStatusPolling = setInterval(this.updateFrontStatus, 2000)
      this.frontPolling = setInterval(this.updateFrontLogs, 2000)
      this.updateFrontStatus()
      this.updateFrontLogs()
    },
    clearServerPolling () {
      if (this.serverStatusPolling) {
        clearInterval(this.serverStatusPolling)
        this.serverStatusPolling = null
      }
      if (this.serverPolling) {
        clearInterval(this.serverPolling)
        this.serverPolling = null
      }
    },
    clearFrontPolling () {
      if (this.frontStatusPolling) {
        clearInterval(this.frontStatusPolling)
        this.frontStatusPolling = null
      }
      if (this.frontPolling) {
        clearInterval(this.frontPolling)
        this.frontPolling = null
      }
    },
    stopServerPolling () {
      this.clearServerPolling()
      this.showServerLogs = false
    },
    stopFrontPolling () {
      this.clearFrontPolling()
      this.showFrontLogs = false
    },
    async updateServerStatus () {
      if (!this.syncServerJobId) return
      try {
        const data = await api.get(`/api/sync_server/status/${encodeURIComponent(this.syncServerJobId)}`)
        if (data && data.success) {
          const st = data.status
          if (st && st !== this.serverLastStatus) {
            this.serverLastStatus = st
            if (['SUCCEEDED', 'FAILED'].includes(st)) {
              this.notify(
                st === 'SUCCEEDED' ? 'success' : 'error',
                this.tr('Sync Server Finished'),
                `${this.syncEnvironmentLabelServer}: ${st}`
              )
              this.clearServerPolling()
            }
          }
        }
      } catch (e) {
        console.error('server sync status error', e)
      }
    },
    async updateServerLogs () {
      if (!this.syncServerJobId) return
      try {
        const data = await api.get(`/api/sync_server/logs/${encodeURIComponent(this.syncServerJobId)}`)
        if (data && data.success && Array.isArray(data.logs)) {
          this.syncServerLogs = [...data.logs]
        }
      } catch (e) {
        console.error('server sync logs error', e)
      }
    },
    async updateFrontStatus () {
      if (!this.syncFrontJobId) return
      try {
        const data = await api.get(`/api/sync_server/status/${encodeURIComponent(this.syncFrontJobId)}`)
        if (data && data.success) {
          const st = data.status
          if (st && st !== this.frontLastStatus) {
            this.frontLastStatus = st
            if (['SUCCEEDED', 'FAILED'].includes(st)) {
              this.notify(
                st === 'SUCCEEDED' ? 'success' : 'error',
                this.tr('Sync Front Finished'),
                `${this.syncEnvironmentLabelFront}: ${st}`
              )
              this.clearFrontPolling()
            }
          }
        }
      } catch (e) {
        console.error('front sync status error', e)
      }
    },
    async updateFrontLogs () {
      if (!this.syncFrontJobId) return
      try {
        const data = await api.get(`/api/sync_server/logs/${encodeURIComponent(this.syncFrontJobId)}`)
        if (data && data.success && Array.isArray(data.logs)) {
          this.syncFrontLogs = [...data.logs]
        }
      } catch (e) {
        console.error('front sync logs error', e)
      }
    },
    async syncBoth () {
      this.syncServerLogs = []
      this.syncFrontLogs = []

      this.syncServerJobId = null
      this.syncFrontJobId = null

      this.serverLastStatus = null
      this.frontLastStatus = null

      this.showServerLogs = true
      this.showFrontLogs = true

      alert(
        'Iniciando actualización del servidor y del front. Esto puede tardar varios minutos. Podés ver el progreso en ambos logs.',
      )

      let res
      try {
        res = await api.post(
          '/api/sync_both/',
          JSON.stringify({
            custom: this.custom,
            branch: this.branch,
          }),
        )
      } catch (e) {
        res = e && e.response ? e.response : (e && e.message ? e.message : e)
      }

      const serverJobId = res && res.server && res.server.job_id
      const frontJobId = res && res.front && res.front.job_id

      if (res && res.success && serverJobId && frontJobId) {
        this.syncServerJobId = serverJobId
        this.syncFrontJobId = frontJobId
        this.startServerPolling()
        this.startFrontPolling()
      } else {
        this.showServerLogs = false
        this.showFrontLogs = false
        alert(res)
      }
    },
    async syncServer () {
      this.syncServerLogs = []
      this.syncServerJobId = null
      this.serverLastStatus = null
      this.showServerLogs = true

      let res
      try {
        res = await api.post(
          '/api/sync_server/',
          JSON.stringify({
            custom: this.custom,
            branch: this.branch,
          }),
        )
      } catch (e) {
        res = e && e.response ? e.response : (e && e.message ? e.message : e)
      }

      if (res && res.success) {
        this.syncServerJobId = res.job_id
        this.startServerPolling()
      } else {
        this.showServerLogs = false
        alert(res)
      }
    },
    async syncFront () {
      this.syncFrontLogs = []
      this.syncFrontJobId = null
      this.frontLastStatus = null
      this.showFrontLogs = true

      let res
      try {
        res = await api.post(
          '/api/sync_front/',
          JSON.stringify({
            custom: this.custom,
            branch: this.branch,
          }),
        )
      } catch (e) {
        res = e && e.response ? e.response : (e && e.message ? e.message : e)
      }

      if (res && res.success) {
        this.syncFrontJobId = res.job_id
        this.startFrontPolling()
      } else {
        this.showFrontLogs = false
        alert(res)
      }
    },

    async getBackup() {
      alert(
        "Iniciando obtención de backup. Esto puede tardar varios minutos. Por favor, no cierre esta ventana hasta que reciba la confirmación.",
      );
      let res = await api.post(
        "/api/get_backup/",
        JSON.stringify({
          custom: this.custom,
        }),
      );
      if (res.success){
        alert("Backup obtenido correctamente.");
      }
    },
    notify (type, title, text) {
      if (this.$notify) {
        this.$notify({ type, title, text })
      } else {
        console.log(`[${type}] ${title}: ${text}`)
      }
    },
  },
};
</script>

<style scoped></style>
